<template>
  <div class="search__interests wc-lg" :class="{ expanded: expanded }">
    <div class="search__interests--inner container">
      <span class="bold">{{ $fn.tr("შეიძლება დაგაინტერესოთ") }}:</span>
      <div class="vacancies_list_header--tags flex">
        <a
          target="_blank"
          :href="item.link"
          class="vacancies_list_header--tag  br-6 bg_gray pointer flex a_center"
          v-for="(item, idx) in items"
          :key="idx"
        >
          <h2 class="f-16 medium">{{ _.get(item, "title") }}</h2>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["expanded"],
  computed: {
    items() {
      return this.$store.state.main.indx.terms.search_interest;
    }
  }
};
</script>

<style lang="sass" scoped>
.search__interests
    background-color: white
    transition: .4s
    &.expanded
        background-color: #F7F7F7
    padding-top: 34px
    padding-bottom: 34px
    span
        margin-bottom: 20px
        display: block
</style>
